export const list = {
  table: {
    id: 'ID',
    price: 'Price',
    total: 'Total',
    quantity: 'Quantity',
    bin: 'Bin',
    updatedAt: 'Import date',
  },
  pageHeader: {
    detergentTitle: 'Detergent detail',
    title: 'Stock in History',
    titleDetergentsList: 'Personal data registration/editing',
    new: 'New',
  },
}
